<template>
  <section>
    <div class="sticky-wrapper">
      <h2>Choose a date and time</h2>
      <p>Your appointment will take around {{ appointment.service.duration }} minutes.</p>

      <booking-date-month
        :appointment="appointment"
        @onSelectedDateSlotChanged="selectDate">
      </booking-date-month>
    </div>

    <div class="btn-container">
      <button :disabled="appointment.date.id === ''" @click="stage('customer')" class="btn">Continue</button>
    </div>
  </section>
</template>

<script>

import BookingDateMonth from "./BookingDateMonth.vue";

export default {
  name: "BookingDate",
  components: {
    BookingDateMonth
  },
  props: ["appointment"],
  methods: {
    stage(stage) {
      this.$emit("stage", stage);
    },
    selectDate(date) {
      this.$emit('selectDate', date);
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style lang="postcss" scoped>
section {
  @apply relative;

  .sticky-wrapper {
    @apply px-[30px] sm:px-0 pt-[45px] text-center sm:w-[635px] mx-auto;

    h2 {
      @apply border-b border-purple-darker pb-5 inline-block mb-7;
    }

    p:first-of-type {
      @apply tracking-wide text-xl sm:text-[20px] mb-[30px] text-grey-darker;
    }
  }

  .btn-container {
    @apply sticky inset-x-0 bottom-0 bg-white shadow-md flex justify-center items-center h-[110px] px-[30px];
    box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.1);

    button.btn {
      @apply w-full sm:w-auto mx-auto;;
    }
  }
}
</style>